import React, { useEffect, useState } from "react";
import { getSlaAnalytics } from "../../api/adminApi";

export default function SlaAnalyticsCards() {
  const [data, setData] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const res = await getSlaAnalytics();
      setData(res.data);
    } catch (e) {
      console.error("Failed to load SLA analytics", e);
    }
  };

  if (!data) return null;

  return (
    <div className="grid-analytics">
      <div className="analytics-card">
        <div className="analytics-label">Avg Hours To Complete Document</div>
        <div className="analytics-value">{Number(data.avgHoursToCompleteDocument || 0).toFixed(1)}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Avg Hours To Complete Signer</div>
        <div className="analytics-value">{Number(data.avgHoursToCompleteSigner || 0).toFixed(1)}</div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Fastest Document</div>
        <div className="analytics-value" style={{ fontSize: 18 }}>{data.fastestDocumentName || "-"}</div>
        <div className="helper-text" style={{ marginTop: 8 }}>
          {Number(data.fastestDocumentHours || 0).toFixed(1)} hours
        </div>
      </div>

      <div className="analytics-card">
        <div className="analytics-label">Slowest Document</div>
        <div className="analytics-value" style={{ fontSize: 18 }}>{data.slowestDocumentName || "-"}</div>
        <div className="helper-text" style={{ marginTop: 8 }}>
          {Number(data.slowestDocumentHours || 0).toFixed(1)} hours
        </div>
      </div>
    </div>
  );
}